import { useContext } from 'react';
import { AutoCompleteContext } from '../context/AutoCompleteContext';

export const useAutoComplete = () => {
    return useContext(AutoCompleteContext);
};
